import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import _ from "@lodash";
import withRouter from "@fuse/core/withRouter";
import { useNavigate } from "react-router-dom";
import { Card } from "@mui/material";

function ShipmentCommunicationHeader(props) {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 items-center justify-between p-8 sm:p-24 relative">
      <div className="flex flex-col md:flex-row items-start md:items-center w-full ">
        <div className="flex flex-col md:flex-row">
          <div className="flex flex-row">
            <Typography
              className="flex items-center sm:mb-12 md:mb-0 pr-0 md:pr-10"
              role="button"
              onClick={() => {
                navigate(-1);
              }}
            >
              <Icon className="text-20">
                {theme.direction === "ltr" ? "arrow_back" : "arrow_forward"}
              </Icon>
            </Typography>
            <Typography className="text-16 sm:text-20x truncate font-semibold pr-0 md:pr-10">
              {props.title}
            </Typography>
          </div>

          {props?.shipmentData?.status && (
            <div className="flex flex-row md:ml-20">
              <Card
                variant="outlined"
                className="flex flex-row md:ml-20 bg-blue-50 rounded-md px-8 py-2 border-none shadow-md"
              >
                <Typography className="flex flex-row text-[13px]">
                  Status:{" "}
                  <div className="font-medium ml-3">
                    {props.shipmentData.status?.name}
                  </div>
                </Typography>
              </Card>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default withRouter(ShipmentCommunicationHeader);
